import { useState } from 'react';
import WarningText from 'components/text/WarningText';
import SubscribeCard from 'components/card/SubscribeCard';
import DisCountModal from 'components/modal/DisCountModal';

import styled from 'styled-components';

import { font } from 'asserts/styles/fonts';
import { color } from 'asserts/styles/colors';
import useAddTicketIncart from 'hooks/useAddTicketInCart';

interface SubscribeCardLayoutProps {
  cartData: MemberShipDataTypes[];
  setCartData: React.Dispatch<React.SetStateAction<MemberShipDataTypes[]>>;
  membershipData?: MemberShipDataTypes[];
  setMembershipData: React.Dispatch<React.SetStateAction<MemberShipDataTypes[] | undefined>>;
}

const SubscribeCardLayout = ({
  membershipData,
  cartData,
  setCartData,
  setMembershipData
}: SubscribeCardLayoutProps) => {
  const [modal, setModal] = useState(false);

  const handleClickPutInCart = useAddTicketIncart(membershipData, cartData, setCartData);

  const handleClickCheckbox = (newData: DivisionItem[], index: number) => {
    if (membershipData && membershipData[index]) {
      const updatedMembershipData = [...membershipData];
      updatedMembershipData[index].divisiondata = newData;
      setMembershipData(updatedMembershipData);
    }
  };

  return (
    <>
      <Wrapper>
        <CardWrapper>
          {membershipData ? (
            membershipData?.map((data, index) => {
              const {
                ebticketidx,
                ticketnamecustomer,
                ticketinfo,
                basicprice,
                editable,
                divisiondata,
                divisionprice,
                screentype,
                cart,
                posturereport,
                romtid,
                paymenttypeidx,
                subscribetype,
                uuid
              } = data;

              return (
                <SubscribeCard
                  key={ebticketidx}
                  name={ticketnamecustomer}
                  subTitle={ticketinfo}
                  divisionprice={divisionprice}
                  uuid={uuid}
                  ticketIdx={ebticketidx}
                  cart={cart}
                  subscribetype={subscribetype}
                  screentype={screentype}
                  basicprice={basicprice}
                  editable={editable}
                  setModal={setModal}
                  cardData={divisiondata}
                  posturereport={posturereport}
                  paymenttypeidx={paymenttypeidx}
                  romtid={romtid}
                  cartData={cartData}
                  licenseData={data?.licenseData ? true : false}
                  membershipData={data}
                  handleClickCheckbox={(data) => handleClickCheckbox(data, index)}
                  handleClickPutInCart={() => handleClickPutInCart(uuid)}
                />
              );
            })
          ) : (
            <TempCompontent></TempCompontent>
          )}
        </CardWrapper>

        <WarningText />
      </Wrapper>
      {modal && <DisCountModal setModal={setModal} />}
    </>
  );
};

export default SubscribeCardLayout;

const Wrapper = styled.div`
  flex: 1;

  & h2 {
    color: ${color.black2};
    ${font.h3_medium};
  }

  & h3 {
    max-width: 690px;
    color: ${color.black2};
    ${font.h4_medium};
  }

  color: ${color.black2};
`;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-bottom: 32px;
`;

const TempCompontent = styled.div`
  position: relative;
  display: flex;
  padding: 32px;
  height: 326px;
  gap: 24px;
  border-radius: 16px;
  background: ${color.white};
  box-shadow: 0px 0px 16px 0px ${color.opacityBlack02};
`;
